import React from "react"

export default function FormFieldError({ name = "", error, placeholder }) {
  return (
    <span
      aria-hidden="true"
      className={`form-message ${error || placeholder ? "form-message__show" : ""}`}
      data-f-linked-name={name}
      data-f-validationerror=""
      id={`${name}_desc`}
    >
      {error || placeholder}
    </span>
  )
}
